"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { formatDateTime } from "../lib/format-date.js";
import { UTC_TIME_ZONE } from "../lib/timezone.js";
import { cn } from "../lib/utils.js";
import { useDisplayTimeZone } from "./time-zone-provider.js";
import { Button } from "./ui/button.js";
export function TimeZoneSetting(_a) {
    var className = _a.className;
    var _b = useDisplayTimeZone(), mode = _b.mode, browserTimeZone = _b.browserTimeZone, setMode = _b.setMode;
    var _c = useState(null), now = _c[0], setNow = _c[1];
    useEffect(function () {
        setNow(new Date());
        var id = setInterval(function () { return setNow(new Date()); }, 30000);
        return function () { return clearInterval(id); };
    }, []);
    var options = [
        {
            key: "local",
            label: "Local time",
            zone: browserTimeZone,
        },
        {
            key: "utc",
            label: "UTC",
            zone: UTC_TIME_ZONE,
        },
    ];
    return (_jsxs("div", { className: cn("space-y-3", className), children: [_jsx("div", { className: "grid gap-2 sm:grid-cols-2", children: options.map(function (option) {
                    var selected = mode === option.key;
                    return (_jsxs(Button, { type: "button", variant: "outline", onClick: function () { return setMode(option.key); }, "aria-pressed": selected, className: cn("h-auto flex-col items-start gap-1 px-4 py-3 text-left whitespace-normal", selected && "border-primary ring-1 ring-primary"), children: [_jsx("span", { className: "text-sm font-medium", children: option.label }), _jsx("span", { className: "text-xs font-normal text-muted-foreground tabular-nums", children: now
                                    ? "".concat(formatDateTime(now, option.zone, "monthDayYearHourMinute"), " \u00B7 ").concat(option.zone)
                                    : " " })] }, option.key));
                }) }), _jsx("p", { className: "text-sm text-muted-foreground", children: "Applies to every date, chart axis and tooltip across the dashboard, including how analytics are bucketed into days. Data is always stored in UTC." })] }));
}
//# sourceMappingURL=time-zone-setting.js.map